import { deviceSwitched } from 'src/store/apps/Common'

/**
 * 为 slice 注册 deviceSwitched 重置：整表重建 initialState 并写入新 requestKey。
 * @param {import('@reduxjs/toolkit').ActionReducerMapBuilder} builder
 * @param {() => Object} createInitialState - 返回 slice 初始 state 的工厂
 */
export const addDeviceSwitchReset = (builder, createInitialState) => {
  builder.addCase(deviceSwitched, (state, action) => {
    const next = createInitialState()
    if ('fetchLoading' in next) {
      next.fetchLoading = true
    }
    next.deviceRequestKey = action.payload?.deviceContext?.requestKey || ''

    return next
  })
}
